export default "__VITE_ASSET__Dcg7nGcR__"